import { DefaultFormFieldLayout } from '@bambi/component-library/src/components/forms/DefaultFormFieldLayout/DefaultFormFieldLayout';
import { FormFieldContainer } from '@bambi/component-library/src/components/forms/layout/FormFieldContainer';

import { FormFieldController } from 'src/common/FormField/FormFieldController';
import { MultiSelect } from 'src/common/primitives/MultiSelect/MultiSelect';
import { useTagOptions } from 'src/common/tags/useTagOptions';

interface PassengerTagsContextFieldProps {
  fieldPath: string;
  label: string;
}

export default function PassengerTagsContextField({
  fieldPath,
  label,
}: PassengerTagsContextFieldProps) {
  const { options, query, setQuery, resetQuery } = useTagOptions();

  return (
    <FormFieldController name={fieldPath}>
      {({ field, fieldState }) => {
        return (
          <FormFieldContainer>
            <DefaultFormFieldLayout
              label={label}
              error={fieldState.error?.message?.toString()}
              inputId={fieldPath}
            >
              <MultiSelect
                options={options}
                searchable
                query={query}
                setQuery={setQuery}
                onClose={resetQuery}
                selected={field.value}
                onChange={(selected) => {
                  field.onChange(selected);
                }}
              />
            </DefaultFormFieldLayout>
          </FormFieldContainer>
        );
      }}
    </FormFieldController>
  );
}
